/**
 * Appends zoom parameters to a URL string
 * @param url - The URL string to append zoom parameters to
 * @param zoomState - Object containing zoom parameters (xAxisMin, xAxisMax, yAxisMin, yAxisMax)
 * @returns The URL string with zoom parameters appended
 */
export function appendZoomParamsToURL(
  url: string,
  zoomState?: Record<string, number | null>
): string {
  try {
    if (!zoomState) {
      return url;
    }

    const zoomKeys = ['xAxisMin', 'xAxisMax', 'yAxisMin', 'yAxisMax'] as const;

    // Check if we have any zoom values to append
    const hasZoomValues = zoomKeys.some(key => zoomState[key] != null);
    if (!hasZoomValues) {
      return url;
    }

    // Parse the URL to handle both relative and absolute URLs
    const isAbsolute = url.startsWith('http');
    const urlObj = new URL(
      url,
      isAbsolute ? undefined : window.location.origin
    );

    zoomKeys.forEach(key => {
      const value = zoomState[key];
      if (value != null) {
        urlObj.searchParams.set(key, value.toString());
      }
    });

    // Return the appropriate format based on whether it was a relative URL
    if (isAbsolute) {
      return urlObj.toString();
    } else {
      // For relative URLs, return pathname + search + hash
      return urlObj.pathname + urlObj.search + urlObj.hash;
    }
  } catch (e) {
    console.error('Error applying zoom params to URL', e);
    return url;
  }
}
